import {Box} from '@esgi/ui/layout';
import {ComponentPropsWithoutRef, forwardRef} from 'react';

export const GridStackItemContent = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof Box>>(
	({className, css, ...props}, forwardedRef) => (
		<Box className={`grid-stack-item-content ${className}`} {...props} ref={forwardedRef} />
	),
);
